import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import CustomSelect from 'components/CustomSelect/CustomSelect';
import { getClientStatusOptions } from 'services/client';

export default function ClientFilters({ onChange }) {
  const [filters, setFilters] = useState({
    status: getClientStatusOptions()[0].id,
  });

  useEffect(() => {
    const data = {};

    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        data[key] = filters[key];
      }
    });

    onChange(data);
  }, [filters]);

  const handleFilterChange = (filter, value) => {
    const data = { ...filters };
    data[filter] = value;

    setFilters(data);
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={3}>
        <CustomSelect
          required
          label="Status"
          translateOptions
          value={filters.status}
          options={getClientStatusOptions()}
          onChange={(value) => handleFilterChange('status', value)}
        />
      </GridItem>
    </GridContainer>
  );
}

ClientFilters.propTypes = {
  onChange: PropTypes.func.isRequired,
};
